import script from "./search-link.vue?vue&type=script&setup=true&lang=js"
export * from "./search-link.vue?vue&type=script&setup=true&lang=js"

import "./search-link.vue?vue&type=style&index=0&id=2692a05c&scoped=true&lang=css"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2692a05c"]])

export default __exports__